// extracted by mini-css-extract-plugin
module.exports = {"gfeButton":"GfeButton_gfeButton__222VQ"};